export type ExpressOption = {
  paymentKey: string;
  provider: string;

  providerInitializationData?: {
    clientId: string;
    commit: boolean;
    currency: string;
    intent: string;
    mustAcceptTermsAndConditions: boolean;
  };
  constraints?: {
    minimumOrderTotal: number;
    maximumOrderTotal: number;
  };
};
export type Consent = {
  klarna?: boolean;
  paypal?: boolean;
};

// eslint-disable-next-line no-restricted-syntax
export enum Events {
  CONSENT_MISSING = 'consent-missing',
  EXPRESS_CHECKOUT_FINISHED = 'express-checkout-finished',
  PAYMENT_CLOSED = 'payment-closed',
  PAYMENT_START = 'payment-start',
  ERROR = 'express-error',
  OUT_OF_CONSTRAINTS = 'out-of-constraints'
}

export type EventMessageMap = {
  [Events.CONSENT_MISSING]: { provider: string; paymentKey: string };
  [Events.EXPRESS_CHECKOUT_FINISHED]: unknown;
  [Events.PAYMENT_CLOSED]: ErrorMessagesMap | unknown;
  [Events.PAYMENT_START]: { provider: string; paymentKey: string };
  [Events.ERROR]: ErrorMessagesMap | unknown;
  [Events.OUT_OF_CONSTRAINTS]: string[];
};

export type EventEmitter = <T extends keyof EventMessageMap>(event: T, message: EventMessageMap[T]) => void;

// eslint-disable-next-line no-restricted-syntax
export enum ErrorMessagesMap {
  WIDGET_CLOSED = 'User closed the widget or cancel the transaction'
}
